import pipefitterApi from './pipefitterApi';

export interface SyncSetupPipeGroupPayload {
  projectNumber: string;
  projectId: number;
  pipeId: number;
  groupId?: string | null;
  previousGroupId?: string | null;
}

export interface SyncSetupPipeGroupResult {
  projectNumber: string;
  pipeId: number;
  groupId: string | null;
  previousGroupId: string | null;
  assignedPipeInfoCount: number;
  unassignedPipeInfoCount: number;
  updatedPipeStatusCount: number;
}

function unwrapData<T>(responseData: unknown): T {
  const data = responseData as { data?: T };
  if (data?.data != null) return data.data;
  return responseData as T;
}

export async function syncSetupPipeGroupAssignment(
  payload: SyncSetupPipeGroupPayload
): Promise<SyncSetupPipeGroupResult> {
  const response = await pipefitterApi.post('/project/sync-setup-pipe-group', payload);
  if (response?.data?.status && response.data.status !== 200) {
    throw new Error(response.data.message || 'Failed to sync setup pipe group');
  }
  return unwrapData<SyncSetupPipeGroupResult>(response.data);
}
